/**
 * Calculate progress percentage based on spaced repetition phase system
 * 
 * Phase Requirements:
 * - Phase 1: 30 successful reviews
 * - Phase 2: 10 successful reviews
 * - Phase 3: 6 successful reviews
 * - Phase 4: 3 successful reviews
 * - Phase 5: 3 successful reviews
 * - Phase 6: 2 successful reviews
 * - Phase 7: 16 successful reviews
 * - Phase 8: Mastered (100%)
 * 
 * Total reviews to mastery: 70
 * 
 * @param {number} currentPhase - Current phase (0-8)
 * @param {number} successfulReviewsInPhase - Number of successful reviews in current phase
 * @returns {number} Progress percentage (0-100)
 */
export function calculateProgressPercentage(currentPhase, successfulReviewsInPhase) {
  // Phase requirements mapping
  const phaseRequirements = {
    1: 30,
    2: 10,
    3: 6,
    4: 3,
    5: 3,
    6: 2,
    7: 16
  };

  // Phase 0 (not started) = 0%
  if (currentPhase === 0) {
    return 0;
  }

  // Phase 8 (Mastered) = 100%
  if (currentPhase >= 8) {
    return 100;
  }

  // Calculate total reviews completed from previous phases
  let totalReviewsCompleted = 0;
  
  for (let phase = 1; phase < currentPhase; phase++) {
    totalReviewsCompleted += phaseRequirements?.[phase] || 0;
  }

  // Add current phase progress
  totalReviewsCompleted += successfulReviewsInPhase || 0;

  // Calculate percentage (total possible reviews = 70)
  const progressPercentage = (totalReviewsCompleted / 70) * 100;

  // Cap at 100%
  return Math.min(Math.round(progressPercentage * 10) / 10, 100);
}

export function cn(...classes) {
  return classes?.filter(Boolean)?.join(' ');
}